import React, { isValidElement, useContext, useState } from "react";
import PricingStore from "Stores/Pricing";
import { ReactComponent as ToggleMinus } from "Assets/Pricing/toggleMinus.svg";
import { ReactComponent as TogglePlus } from "Assets/Pricing/togglePlus.svg";
import { ReactComponent as MostPopular } from "Assets/Pricing/mostPopular.svg";
import { ReactComponent as Cross } from "Assets/Pricing/cross.svg";
import { ReactComponent as Check } from "Assets/Pricing/check.svg";
import ToggleContext from "./context/ToggleContext";
import CustomTooltip from "Components/common/CustomTooltip";
import { confirmationPopupState } from "Components/common/confirmationPopup";
import userDetail from "Stores/userDetail";
import Utils from "Utils/utils";
import FeatureDemoVideo from "Components/common/FeatureDemoVideo";

const FeatureComparisonTable = (props = {}) => {
  const { planData = [], subscriptionId = "" } = props || {};

  return (
    <section className="feature-comparison-section">
      <div className="container">
        <div className="table-container">
          <div
            className="mostPopularWrapper"
            id="comparePlans"
            style={{ position: "relative" }}
          >
            <div className="mostPopularBadgeText">
              To make Most Popular visible
            </div>
            <table className="comparison-table">
              <TableHeader
                planData={planData}
                subscriptionId={subscriptionId}
              />
              <TableBody planData={planData} />
            </table>
          </div>
        </div>
      </div>
    </section>
  );
};

const TableHeader = (props = {}) => {
  const { planData = [], subscriptionId = "" } = props || {};
  const { team, userLoggedIn } = userDetail.userInfo || {};
  const { planName, inFreePlan } = userDetail?.userFeatureFlag || {};
  let { isChecked, setIsChecked } = useContext(ToggleContext);

  const getPlanPrice = (planName = "") => {
    const plan = planData?.find(item => item?.name.toLowerCase() === planName);
    return isChecked ? plan?.annualPrice : plan?.price;
  };

  const TABLE_HEADER = [
    {
      name: "Free",
      color: "#3953FB",
      btnStyle: "primary",
      link: "signup",
      type: "redirect",
      id: "tryForFree",
      price: getPlanPrice("free"),
      priceText: "/Forever"
    },
    {
      name: "Basic",
      color: "#FA6B63",
      btnStyle: "outline",
      link: "signup",
      type: "redirect",
      id: "basicTryForFree",
      price: getPlanPrice("basic"),
      priceText: "/ User / Month"
    },
    {
      name: "Pro",
      color: "#01B018",
      btnStyle: "outline",
      link: "signup",
      type: "redirect",
      id: "proTryForFree",
      price: getPlanPrice("pro"),
      priceText: "/ User / Month",
      isPopular: true
    },
    {
      name: "Enterprise",
      color: "#AD007F",
      btnStyle: "outline",
      type: "chat",
      price: "Custom",
      priceText: ""
    }
  ];

  const [toogleType, setToogleType] = useState(
    PricingStore.paymentFormInfo.annual
  );

  const getTogglePlanType = value => {
    PricingStore.setPaymentFormInfo({ annual: value });
    setToogleType(value);
  };

  const upgradeBtn = (plan = {}) => {
    let planDisplayName = plan?.displayName?.toLowerCase();
    if (userLoggedIn) {
      if (!team) {
        confirmationPopupState.setPopupValues({
          title: "Pricing Purchase Request?",
          content: `Please contact your account administrator to upgrade your account`,
          actionBtnText: "Ok",
          needCancelBtn: false,
          callback: () => {
            confirmationPopupState.setShowPopup(false);
          }
        });
        confirmationPopupState.setShowPopup(true);
      } else {
        if (
          ["basic", "pro"].includes(planName?.toLowerCase()) &&
          ["unlimited", "pro", "basic"].includes(planDisplayName)
        ) {
          confirmationPopupState.setPopupValues({
            content: `Please reach out to <a href="mailto:support@salesgear.io" target="_blank" rel="noopener noreferrer" >support@salesgear.io</a> to upgrade to ${plan?.displayName} plan`,
            actionBtnText: "Ok",
            needCancelBtn: false,
            callback: () => {
              confirmationPopupState.setShowPopup(false);
            }
          });
          confirmationPopupState.setShowPopup(true);
        }
      }
    } else {
      if (planDisplayName !== "custom") {
        props.history.push("/signup");
      }
    }
  };

  const getActionButton = planObj => {
    let buttonValue = "";
    const { displayName } = planObj;

    let idValue =
      displayName?.toLowerCase() == "custom" ? "my_custom_link" : "";

    if (displayName?.toLowerCase() === "custom") {
      buttonValue = "Contact Sales";
    } else if (displayName?.toLowerCase() === "free") {
      buttonValue = "";
    } else {
      buttonValue = "Upgrade";
    }

    return (
      <div
        id={idValue}
        className={`${buttonValue ? "" : "noBorder"} upgradeBtn`}
        onClick={() => upgradeBtn(planObj)}
      >
        {buttonValue}
      </div>
    );
  };

  const showCurrentPlanDom = plan => {
    const { displayName = "" } = plan;

    if (subscriptionId !== null) {
      if (displayName?.toLowerCase() === planName?.toLowerCase()) {
        return true;
      }
    } else {
      return inFreePlan && displayName?.toLowerCase() === "free";
    }
    return false;
  };

  return (
    <thead>
      <tr>
        <th></th>
        {TABLE_HEADER.map(
          ({ name, color, price, priceText, isPopular }, index) => (
            <th
              key={index}
              style={
                index === 2
                  ? {
                      background: `#EBECF0`,
                      borderTop: `2px solid #3953FB`,
                      borderRight: `2px solid #3953FB`,
                      borderLeft: `2px solid #3953FB`,
                      position: `relative`,
                      overflow: `visible`
                    }
                  : {}
              }
            >
              {index === 2 && (
                <div className="mostPopularBadge">
                  <MostPopular />
                </div>
              )}
              <div
                className={`priceDataHeader ${
                  isPopular ? "isPopularPlanCard" : ""
                }`}
              >
                <h6 style={{ color }}>{name}</h6>
                <div className="priceData">
                  <span>
                    <sup className="superscript">$</sup>
                    {price}
                  </span>
                  <sub className="subscript">{priceText}</sub>
                </div>
                {showCurrentPlanDom(planData[index]) ? (
                  <div
                    className="currentPlanBtn"
                    onClick={() => props.history.push("/settings/billing")}
                  >
                    Current Plan
                  </div>
                ) : (
                  getActionButton(planData[index])
                )}
              </div>
            </th>
          )
        )}
      </tr>
    </thead>
  );
};

const TableBody = (props = {}) => {
  const { planData = [] } = props || {};

  const [collapsedSections, setCollapsedSections] = useState({});

  const [tooltipVisible, setTooltipVisible] = useState(null);
  const [hoveredItem, setHoveredItem] = useState(null);

  const getTooltipContent = (planIdx, item, val) => {
    const tooltipData = [
      {
        snImportLimit: `Import ${
          +val < 10 ? +val % 10 : val
        } list from LinkedIn Sales Navigator, available for lifetime.`,
        snContactsImport: `Import up to ${val} contacts from LinkedIn Sales Navigator.`,
        phnCredits: `Find up to ${val} prospect phone numbers for free, available for lifetime.`,
        freeUsphn:
          "Get a free US phone number to use as your 'From' number for outbound calls.",
        emailCredits: `Find up to ${val} prospect email addresses per month, with a daily limit of 10.`,
        noInboxes: `Connect up to ${
          +val < 10 ? +val % 10 : val
        } email accounts to send outreach emails.`,
        emailSends: `Send up to ${val}  emails per month, with a limit of 20 per inbox per day.`,
        callingMinutes:
          "Lifetime access to 60 free calling minutes for US & Canada.",
        waDailyLimit: `Send up to ${val} WhatsApp messages per day on the Free plan.`
      },
      {
        snImportLimit: `Import up to ${
          +val < 10 ? +val % 10 : val
        } lists from LinkedIn Sales Navigator per month.`,
        snContactsImport: `Import up to ${val} contacts from LinkedIn Sales Navigator per month.`,
        phnCredits: `Find up to ${val} prospect phone numbers per month.`,
        freeUsphn:
          "Get a free US phone number to use as your 'From' number for outbound calls.",
        emailCredits: `Find up to ${val} prospect email addresses per month, with a daily limit of 50.`,
        noInboxes:
          "No limits—connect as many email accounts as needed for sending emails.",
        emailSends: `Send up to ${val} emails per month, with no daily limit per inbox.`,
        callingMinutes: `Get ${val} free calling minutes per month for US & Canada.`,
        waDailyLimit: `Send up to ${val} WhatsApp messages per day from your connected account.`
      },
      {
        snImportLimit: `Import up to ${
          planIdx == 2 ? (+val < 10 ? +val % 10 : val) : 10
        } lists from LinkedIn Sales Navigator per month.`,
        snContactsImport: `Import up to ${val} contacts from LinkedIn Sales Navigator per month.`,
        phnCredits: `Find up to ${val} prospect phone numbers per month.`,
        freeUsphn:
          "Get a free US phone number to use as your 'From' number for outbound calls.",
        emailCredits: `Find up to ${val} prospect email addresses per month, with no daily limit.`,
        noInboxes:
          "No limits—connect as many email accounts as needed for sending emails.",
        emailSends: `Send up to ${val} emails per month, ideal for high-volume outreach, with no per-inbox limit.`,
        callingMinutes: `Get ${val} free calling minutes per month for US & Canada.`,
        waDailyLimit: `Send up to ${val} WhatsApp messages per day from your connected account.`
      },
      {
        snImportLimit:
          "Import unlimited lists from LinkedIn Sales Navigator every month.",
        snContactsImport: `Import up to ${val} contacts from LinkedIn Sales Navigator per month.`,
        phnCredits: `Find up to ${val} prospect phone numbers per month, or customize as needed.`,
        freeUsphn:
          "Get a free US phone number to use as your 'From' number for outbound calls.",
        emailCredits: "Flexible email credits to match your prospecting needs.",
        noInboxes:
          "No limits—connect as many email accounts as needed for sending emails.",
        emailSends: "Flexible email sending limits tailored to your needs.",
        callingMinutes:
          "Flexible calling minutes tailored to your business needs.",
        waDailyLimit:
          "Flexible WhatsApp daily message limits tailored to your needs."
      }
    ];

    return tooltipData[planIdx]?.[item] || "No information available.";
  };

  const handleTooltipVisibility = (planName, item, isVisible) => {
    if (isVisible) {
      setTooltipVisible(planName);
      setHoveredItem(item);
    } else {
      setTooltipVisible(null);
      setHoveredItem(null);
    }
  };

  const FeaturePlayer = (props = {}) => {
    const { feature = "", videoType = "" } = props || {};
    return (
      <span className="inline-feature">
        {feature}
        {<FeatureDemoVideo isVideoPlayer={true} type={videoType} />}
      </span>
    );
  };

  const getTooltipContentForCredits = (planName, creditConsumption) => {
    const tooltipData = {
      free: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      basic: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      pro: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      custom: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ],
      proplus: [
        {
          email: {
            credit: `1 Email Address`,
            creditText: `${creditConsumption?.email} ${
              creditConsumption?.email > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          phone: {
            credit: `1 Phone Number`,
            creditText: `${creditConsumption?.phone} ${
              creditConsumption?.phone > 1 ? "Credits" : "Credit"
            }`
          }
        },
        {
          deepResearch: {
            credit: `1 Deep Research`,
            creditText: `${creditConsumption?.deepResearch} ${
              creditConsumption?.deepResearch > 1 ? "credits" : "credit"
            }`
          }
        }
      ]
    };

    return tooltipData[planName] || "No information available.";
  };

  const FEATURE_COMPARISON_TABLE = [
    {
      name: (
        <FeaturePlayer feature="Email Sequencing" videoType={"sequencing"} />
      ),
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: "Email warming",
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: <FeaturePlayer feature="Dialer" videoType={"dialer"} />,
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer feature="LinkedIn Outreach" videoType={"liOutreach"} />
      ),
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer
          feature="Sales navigator import"
          videoType={"snImport"}
        />
      ),
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer
          feature="Discover Database"
          videoType={"discoverDatabase"}
        />
      ),
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer
          feature="CRM Integrations"
          videoType={"crmIntegrations"}
        />
      ),
      type: "feature",
      list: ["check", "check", "check", "check"]
    },
    {
      name: "Data & Usage Limits",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: "Credits",
      isTotalCredits: true,
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, indx) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return Utils.pricingNumberWithCommas(item?.creditsEligible);
      }),
      tooltipFeatureText: "emailCredits"
    },
    {
      name: "Bulk Purchase",
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.bulkPurchaseEnabled ? "check" : "close";
      })
    },
    {
      name: "Email Outreach",
      type: "title",
      paddingTop: "50px"
    },
    {
      name: (
        <FeaturePlayer feature="Number of Inboxes" videoType={"noOfInboxes"} />
      ),
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, ind) => {
        return item?.noOfInboxesEligible > 5
          ? "Unlimited"
          : Utils.pricingNumberWithCommas(item.noOfInboxesEligible);
      }),
      tooltipFeatureText: "noInboxes"
    },
    {
      name: (
        <FeaturePlayer
          feature="Number of Email Warming Accounts"
          videoType={"emailWarming"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.warmingAccountsEligible > 5
          ? "Unlimited"
          : Utils.pricingNumberWithCommas(item.warmingAccountsEligible);
      })
    },
    {
      name: <FeaturePlayer feature="A/B Testing" videoType={"abTesting"} />,
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.abTestingEnabled ? "check" : "close";
      })
    },
    {
      name: "Email Sends Per Month",
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return Utils.pricingNumberWithCommas(item?.emailSendLimit);
      }),
      tooltipFeatureText: "emailSends"
    },
    {
      name: "Email Sends Per Day",
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.dailySendLimit > 20
          ? "No Limit"
          : Utils.pricingNumberWithCommas(item.dailySendLimit);
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Multiple Inboxes"
          videoType={"multipleInboxes"}
        />
      ),
      type: "feature",
      list: planData?.map((item, idx) => {
        return item?.multipleInboxEnabled ? "check" : "close";
      })
    },
    {
      name: "Inbox Rotation",
      type: "feature",
      list: ["close", "check", "check", "check"]
    },
    {
      name: "Secondary Domain Email Setup Assistance",
      type: "feature",
      list: ["close", "check", "check", "check"]
    },
    {
      name: "Calling",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: (
        <FeaturePlayer
          feature="Free US Phone Number"
          videoType={"freeUSPhone"}
        />
      ),
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, ind) => {
        return Utils.pricingNumberWithCommas(item?.freePhoneNumbersEligible);
      }),
      tooltipFeatureText: "freeUsphn"
    },
    {
      name: (
        <FeaturePlayer
          feature="Add Additional US Phone Numbers"
          videoType={"addUsPhoneNum"}
        />
      ),
      type: "feature",
      list: ["close", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer
          feature="Calling Minutes (US/Canada)"
          videoType={"callingMinutes"}
        />
      ),
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return Utils.pricingNumberWithCommas(
          item?.usFreeCallingMinutesEligible
        );
      }),
      tooltipFeatureText: "callingMinutes"
    },
    {
      name: (
        <FeaturePlayer
          feature="Rest of the World Calling"
          videoType={"globalCalling"}
        />
      ),
      type: "feature",
      list: ["close", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer
          feature="Add More Calling Credits"
          videoType={"addMoreCallingCredits"}
        />
      ),
      type: "feature",
      list: ["close", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer feature="Call Recording" videoType={"callRecording"} />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.recordingEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Custom Call Outcomes"
          videoType={"customCallOutComes"}
        />
      ),
      type: "feature",
      list: ["close", "close", "check", "check"]
    },
    {
      name: "LinkedIn Outreach",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: (
        <FeaturePlayer
          feature="Connection Requests"
          videoType={"liConnectionRequests"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.liMaxInvitePerMonth > 1000
          ? "Custom"
          : Utils.pricingNumberWithCommas(item.liMaxInvitePerMonth);
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Daily Connection Request Limit"
          videoType={"liDailyConnectionRequestLimit"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return Utils.pricingNumberWithCommas(item?.liMaxInvitePerDay);
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Auto-Withdraw Connection Requests"
          videoType={"liAutoWithDrawConnectionRequest"}
        />
      ),
      type: "feature",
      list: ["close", "check", "check", "check"]
    },
    {
      name: (
        <FeaturePlayer
          feature="LinkedIn Messages Sent"
          videoType={"liMessagesSent"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.liMaxMessagesPerMonth > 1000
          ? "Custom"
          : Utils.pricingNumberWithCommas(item.liMaxInvitePerMonth);
      })
    },
    {
      name: "Daily Messages Sent Limit",
      type: "feature",
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return Utils.pricingNumberWithCommas(item?.liMaxMessagesPerDay);
      })
    },
    {
      name: "Sales Navigator Import Limit",
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, ind) => {
        if (item?.snImportEligible >= 1000) {
          return "Custom";
        }
        return (
          item?.snImportEnabled &&
          Utils.pricingNumberWithCommas(item?.snImportEligible)
        );
      }),
      tooltipFeatureText: "snImportLimit"
    },
    {
      name: (
        <FeaturePlayer
          feature="Sales Navigator Contacts Import"
          videoType={"snContactsImport"}
        />
      ),
      type: "feature",
      isToolTip: true,
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return (
          item?.snImportEnabled &&
          Utils.pricingNumberWithCommas(item?.snContactsEligible)
        );
      }),
      tooltipFeatureText: "snContactsImport"
    },
    {
      name: "WhatsApp Outreach",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: "Daily Message Limit",
      type: "feature",
      isToolTip: true,
      tooltipFeatureText: "waDailyLimit",
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Custom";
        }
        return item?.waMaxMessagesPerDay > 0
          ? Utils.pricingNumberWithCommas(item?.waMaxMessagesPerDay)
          : false;
      })
    },
    {
      name: "Integrations",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: (
        <FeaturePlayer
          feature="CRM Integrations"
          videoType={"crmIntegrations"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        if (item.name.toLowerCase() === "custom") {
          return "Automatic 2-way sync";
        }
        return "Manual";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Slack Integration"
          videoType={"slackIntegration"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.slackIntegrationEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Zapier Integration"
          videoType={"zappierIntegration"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.zapierIntegrationEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer feature="Custom Stages" videoType={"customStages"} />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.contactStagesEnabled ? "check" : "close";
      })
    },
    {
      name: <FeaturePlayer feature="Manual Tasks" videoType={"manualTasks"} />,
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.taskEnabled ? "check" : "close";
      })
    },
    {
      name: "Other Features",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: "Branded URL",
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.brandedUrlEnabled ? "check" : "close";
      })
    },
    {
      name: "Auto BCC",
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.autoBccEnabled ? "check" : "close";
      })
    },
    {
      name: "Unsubscribe Link",
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.unsubscribeEnabled ? "check" : "close";
      })
    },
    {
      name: "Email Validation",
      type: "feature",
      list: ["close", "Usage-based", "Usage-based", "Usage-based"]
    },
    {
      name: "Advanced Features",
      type: "title",
      paddingTop: "10px"
    },
    {
      name: (
        <FeaturePlayer feature="Custom Fields" videoType={"customFields"} />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return (
          item?.customFieldsEnabled &&
          Utils.pricingNumberWithCommas(item?.customFieldsCount)
        );
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="AI Writing Assistant"
          videoType={"aiWritingAssitance"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.writingAssistantEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Do Not Contact Domains"
          videoType={"doNotContactDomains"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.donotContactEnabled ? "check" : "close";
      })
    },
    {
      name: <FeaturePlayer feature="Triggers" videoType={"triggers"} />,
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.triggersEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Custom Contact Stages"
          videoType={"customContactStages"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.contactStagesEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="LinkedIn Chrome Extension"
          videoType={"linkedInChromeExt"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.linkedInExtEnabled ? "check" : "close";
      })
    },
    {
      name: (
        <FeaturePlayer
          feature="Gmail Chrome Extension"
          videoType={"gmailChromExtension"}
        />
      ),
      type: "feature",
      list: planData?.map((item, ind) => {
        return item?.chromeExtEnabled ? "check" : "close";
      })
    }
  ];

  const toggleSection = index => {
    setCollapsedSections(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  let currentSectionIndex = -1;

  return (
    <tbody>
      {FEATURE_COMPARISON_TABLE.map(
        (
          {
            name = "",
            type = "",
            list = [],
            isToolTip = false,
            tooltipFeatureText = "",
            isTotalCredits = false
          },
          index
        ) => {
          if (type === "title") {
            currentSectionIndex = index;
            return (
              <tr
                key={index}
                className="table-title"
                onClick={() => toggleSection(index)}
                style={{ cursor: "pointer" }}
              >
                <th colSpan="100%" className="collapsibleHeader">
                  <div className="headerContent">
                    {collapsedSections[index] ? (
                      <TogglePlus className="toggleIcon" />
                    ) : (
                      <ToggleMinus className="toggleIcon" />
                    )}
                    <span>{name}</span>
                  </div>
                </th>
              </tr>
            );
          }

          return (
            !collapsedSections[currentSectionIndex] && (
              <tr key={index} className="table-row">
                <th>{name}</th>
                {list.map((item, idx) => (
                  <td
                    key={idx}
                    style={{
                      ...(idx === 2
                        ? {
                            background: `#EBECF0`,
                            borderRight: `2px solid #3953FB`,
                            borderLeft: `2px solid #3953FB`
                          }
                        : {}),
                      ...(idx === 2 &&
                      index === FEATURE_COMPARISON_TABLE.length - 1
                        ? { borderBottom: `2px solid #3953FB` }
                        : {})
                    }}
                    className={
                      item === "check"
                        ? "check"
                        : item === "close"
                        ? "close"
                        : "text"
                    }
                  >
                    {isToolTip ? (
                      item === "close" ? (
                        <Cross />
                      ) : (
                        <div
                          className="tooltipTarget"
                          style={{
                            cursor: "pointer",
                            textDecoration: "underline dotted"
                          }}
                          onMouseEnter={() => {
                            if (isTotalCredits) {
                              handleTooltipVisibility(
                                planData[idx]?.name?.toLowerCase(),
                                planData[idx]?.name?.toLowerCase(),
                                true
                              );
                            } else {
                              handleTooltipVisibility(
                                `Plan ${idx + 1}`,
                                isValidElement(name)
                                  ? name.props.feature
                                  : name,
                                true
                              );
                            }
                          }}
                          onMouseLeave={() => {
                            if (isTotalCredits) {
                              handleTooltipVisibility(
                                planData[idx]?.name?.toLowerCase(),
                                planData[idx]?.name?.toLowerCase(),
                                false
                              );
                            } else {
                              handleTooltipVisibility(
                                `Plan ${idx + 1}`,
                                isValidElement(name)
                                  ? name.props.feature
                                  : name,
                                false
                              );
                            }
                          }}
                        >
                          {item}
                          {isTotalCredits
                            ? tooltipVisible ===
                                planData[idx]?.name?.toLowerCase() &&
                              hoveredItem ===
                                planData[idx]?.name?.toLowerCase() && (
                                <CustomTooltip
                                  dataOutreachCreditsContent={getTooltipContentForCredits(
                                    planData[idx]?.name?.toLowerCase(),
                                    planData[idx]?.creditConsumption
                                  )}
                                  isDataOutreachData={true}
                                  className="tooltipTotalCreditsFeatureTable"
                                />
                              )
                            : tooltipVisible === `Plan ${idx + 1}` &&
                              hoveredItem ===
                                (isValidElement(name)
                                  ? name.props.feature
                                  : name) && (
                                <CustomTooltip
                                  text={getTooltipContent(
                                    `${idx}`,
                                    tooltipFeatureText,
                                    item
                                  )}
                                />
                              )}
                        </div>
                      )
                    ) : item === "check" ? (
                      <Check />
                    ) : item === "close" ? (
                      <Cross />
                    ) : (
                      item
                    )}
                  </td>
                ))}
              </tr>
            )
          );
        }
      )}
    </tbody>
  );
};

export default FeatureComparisonTable;
